export const SERVICE_CATEGORIES = [
  {
    id: "vet-health",
    name: "Veterinary & Health Care",
    services: [
      "Home Vet Visits",
      "Online Vet Consultation",
      "Emergency Vet Service",
      "Vaccination Service",
      "Pet Testing",
      "Pet DNA Testing",
      "Pet Physiotherapy",
      "Pet Rehabilitation",
      "Pet Boarding for Medical Care",
      "Pet Microchipping",
    ],
  },
  {
    id: "grooming-wellness",
    name: "Grooming, Wellness & Spa",
    services: [
      "Pet Grooming",
      "Mobile Pet Grooming",
      "Pet Massage & Spa",
    ],
  },
  {
    id: "boarding-daycare",
    name: "Boarding, Daycare & Sitting",
    services: [
      "Pet Boarding",
      "Pet Hotel",
      "Pet Daycare",
      "Pet Sitting",
    ],
  },
  {
    id: "walking-training",
    name: "Walking, Training & Behaviour",
    services: [
      "Pet Walking",
      "Pet Training",
      "Pet Behaviour Training",
      "Dog Behaviourist",
      "Pet First Aid Training",
    ],
  },
  {
    id: "food-nutrition",
    name: "Food, Nutrition & Meals",
    services: [
      "Dog Food Service",
      "Pet Food Delivery",
      "Pet Meal Subscription",
      "Pet Nutrition",
      "Pet Nutritionist Consultation",
    ],
  },
  {
    id: "transport-travel",
    name: "Transport, Travel & Relocation",
    services: [
      "Pet Transport",
      "Pet Taxi",
      "Pet Airport Transport",
      "Pet Travel Documentation",
      "International Pet Relocation",
    ],
  },
  {
    id: "insurance-protection",
    name: "Insurance & Protection",
    services: [
      "Pet Insurance",
    ],
  },
  {
    id: "adoption-community",
    name: "Adoption, Rescue & Community",
    services: [
      "Pet Adoption Service",
      "Pet Rescue Service",
    ],
  },
  {
    id: "store-pharmacy",
    name: "Stores, Pharmacy & Accessories",
    services: [
      "Pet Store",
      "Online Pet Store",
      "Pet Accessories Shop",
      "Pet Pharmacy",
      "Pet Purchase Shop",
    ],
  },
  {
    id: "breeding-registration",
    name: "Breeding & Registration",
    services: [
      "Dog Breeding",
      "Pet Registration",
    ],
  },
  {
    id: "photo-art-events",
    name: "Photography, Art & Events",
    services: [
      "Pet Photography",
      "Pet Art",
      "Pet Event Planning",
      "Pet Cafe",
    ],
  },
  {
    id: "memorial",
    name: "Memorial",
    services: [
      "Pet Cremation",
      "Pet Funeral Service",
      "Pet Cemetery",
    ],
  },
  {
    id: "home-support",
    name: "Cleaning & Home Support",
    services: [
      "Pet Waste Cleaning Service",
    ],
  },
];

export const MAJOR_INDIAN_CITIES = [
  "Ahmedabad",
  "Allahabad (Prayagraj)",
  "Amritsar",
  "Aurangabad",
  "Bengaluru",
  "Bhopal",
  "Bhubaneswar",
  "Chandigarh",
  "Chennai",
  "Coimbatore",
  "Dehradun",
  "Delhi",
  "Faridabad",
  "Ghaziabad",
  "Goa",
  "Gurugram",
  "Guwahati",
  "Gwalior",
  "Hubli-Dharwad",
  "Hyderabad",
  "Indore",
  "Jaipur",
  "Jalandhar",
  "Jammu",
  "Jamshedpur",
  "Kanpur",
  "Kochi",
  "Kolkata",
  "Kota",
  "Lucknow",
  "Ludhiana",
  "Madurai",
  "Mangaluru",
  "Meerut",
  "Mumbai",
  "Mysuru",
  "Nagpur",
  "Nashik",
  "Noida",
  "Patna",
  "Pimpri-Chinchwad",
  "Pune",
  "Raipur",
  "Rajkot",
  "Ranchi",
  "Srinagar",
  "Surat",
  "Thane",
  "Thiruvananthapuram",
  "Tiruchirappalli",
  "Udaipur",
  "Vadodara",
  "Varanasi",
  "Vijayawada",
  "Visakhapatnam",
];

export const CITY_COORDINATES = {
  "ahmedabad": { lat: 23.0225, lng: 72.5714 },
  "allahabad (prayagraj)": { lat: 25.4358, lng: 81.8463 },
  "amritsar": { lat: 31.6340, lng: 74.8723 },
  "aurangabad": { lat: 19.8762, lng: 75.3433 },
  "bengaluru": { lat: 12.9716, lng: 77.5946 },
  "bhopal": { lat: 23.2599, lng: 77.4126 },
  "bhubaneswar": { lat: 20.2961, lng: 85.8245 },
  "chandigarh": { lat: 30.7333, lng: 76.7794 },
  "chennai": { lat: 13.0827, lng: 80.2707 },
  "coimbatore": { lat: 11.0168, lng: 76.9558 },
  "dehradun": { lat: 30.3165, lng: 78.0322 },
  "delhi": { lat: 28.6139, lng: 77.2090 },
  "faridabad": { lat: 28.4089, lng: 77.3178 },
  "ghaziabad": { lat: 28.6692, lng: 77.4538 },
  "goa": { lat: 15.4909, lng: 73.8278 },
  "gurugram": { lat: 28.4595, lng: 77.0266 },
  "guwahati": { lat: 26.1445, lng: 91.7362 },
  "gwalior": { lat: 26.2183, lng: 78.1828 },
  "hubli-dharwad": { lat: 15.3647, lng: 75.1240 },
  "hyderabad": { lat: 17.3850, lng: 78.4867 },
  "indore": { lat: 22.7196, lng: 75.8577 },
  "jaipur": { lat: 26.9124, lng: 75.7873 },
  "jalandhar": { lat: 31.3260, lng: 75.5762 },
  "jammu": { lat: 32.7266, lng: 74.8570 },
  "jamshedpur": { lat: 22.8046, lng: 86.2029 },
  "kanpur": { lat: 26.4499, lng: 80.3319 },
  "kochi": { lat: 9.9312, lng: 76.2673 },
  "kolkata": { lat: 22.5726, lng: 88.3639 },
  "kota": { lat: 25.2138, lng: 75.8648 },
  "lucknow": { lat: 26.8467, lng: 80.9462 },
  "ludhiana": { lat: 30.9010, lng: 75.8573 },
  "madurai": { lat: 9.9252, lng: 78.1198 },
  "mangaluru": { lat: 12.9141, lng: 74.8560 },
  "meerut": { lat: 28.9845, lng: 77.7064 },
  "mumbai": { lat: 19.0760, lng: 72.8777 },
  "mysuru": { lat: 12.2958, lng: 76.6394 },
  "nagpur": { lat: 21.1458, lng: 79.0882 },
  "nashik": { lat: 19.9975, lng: 73.7898 },
  "noida": { lat: 28.5355, lng: 77.3910 },
  "patna": { lat: 25.5941, lng: 85.1376 },
  "pimpri-chinchwad": { lat: 18.6298, lng: 73.7997 },
  "pune": { lat: 18.5204, lng: 73.8567 },
  "raipur": { lat: 21.2514, lng: 81.6296 },
  "rajkot": { lat: 22.3039, lng: 70.8022 },
  "ranchi": { lat: 23.3441, lng: 85.3096 },
  "srinagar": { lat: 34.0837, lng: 74.7973 },
  "surat": { lat: 21.1702, lng: 72.8311 },
  "thane": { lat: 19.2183, lng: 72.9781 },
  "thiruvananthapuram": { lat: 8.5241, lng: 76.9366 },
  "tiruchirappalli": { lat: 10.7905, lng: 78.7047 },
  "udaipur": { lat: 24.5854, lng: 73.7125 },
  "vadodara": { lat: 22.3072, lng: 73.1812 },
  "varanasi": { lat: 25.3176, lng: 82.9739 },
  "vijayawada": { lat: 16.5062, lng: 80.6480 },
  "visakhapatnam": { lat: 17.6868, lng: 83.2185 },
};

export const SERVICE_NAME_OPTIONS = SERVICE_CATEGORIES.flatMap((category) =>
  category.services.map((serviceName) => ({
    category: category.name,
    name: serviceName,
  })),
);

export const CATEGORY_ICONS = {
  "Veterinary & Health Care": "🩺",
  "Grooming, Wellness & Spa": "✨",
  "Boarding, Daycare & Sitting": "🏡",
  "Walking, Training & Behaviour": "🎓",
  "Food, Nutrition & Meals": "🥣",
  "Transport, Travel & Relocation": "🚖",
  "Insurance & Protection": "🛡️",
  "Adoption, Rescue & Community": "🤝",
  "Stores, Pharmacy & Accessories": "🛍️",
  "Breeding & Registration": "📄",
  "Photography, Art & Events": "📸",
  Memorial: "🕊️",
  "Cleaning & Home Support": "🧹",
};

export const CATEGORY_ICON_IMAGES = {
  "Veterinary & Health Care": "https://api.iconify.design/mdi/stethoscope.svg?color=%231d4ed8&width=96&height=96",
  "Grooming, Wellness & Spa": "https://api.iconify.design/mdi/content-cut.svg?color=%231d4ed8&width=96&height=96",
  "Boarding, Daycare & Sitting": "https://api.iconify.design/mdi/home-heart.svg?color=%231d4ed8&width=96&height=96",
  "Walking, Training & Behaviour": "https://api.iconify.design/mdi/dog-side.svg?color=%231d4ed8&width=96&height=96",
  "Food, Nutrition & Meals": "https://api.iconify.design/mdi/bowl-mix.svg?color=%231d4ed8&width=96&height=96",
  "Transport, Travel & Relocation": "https://api.iconify.design/mdi/car-estate.svg?color=%231d4ed8&width=96&height=96",
  "Insurance & Protection": "https://api.iconify.design/mdi/shield-check.svg?color=%231d4ed8&width=96&height=96",
  "Adoption, Rescue & Community": "https://api.iconify.design/mdi/hand-heart.svg?color=%231d4ed8&width=96&height=96",
  "Stores, Pharmacy & Accessories": "https://api.iconify.design/mdi/storefront-outline.svg?color=%231d4ed8&width=96&height=96",
  "Breeding & Registration": "https://api.iconify.design/mdi/file-document-check-outline.svg?color=%231d4ed8&width=96&height=96",
  "Photography, Art & Events": "https://api.iconify.design/mdi/camera.svg?color=%231d4ed8&width=96&height=96",
  Memorial: "https://api.iconify.design/mdi/flower-outline.svg?color=%231d4ed8&width=96&height=96",
  "Cleaning & Home Support": "https://api.iconify.design/mdi/spray-bottle.svg?color=%231d4ed8&width=96&height=96",
};
